export default "__VITE_ASSET__s49uoQLJ__"